import React from 'react';
import './sizesSection.scss';
import {useTranslation} from "react-i18next";

const SizesSection = () => {
	const { t } = useTranslation();

	return (
		<div className="sizes">
			<div className={`main__bg_animations_item c10`} />
			<div className={`main__bg_animations_item c11`} />
			<div className={`main__bg_animations_item c12`} />
			<div className="sizes__content">
				<div className="sizes__content_header">
					<h3>{t('sizes.title')}</h3>
				</div>
			</div>
			<div className="sizes__content_data">
				<div className="sizes__content_data_item large">
					<div className="images">
						<img
							className={`sizeImage`}
							src={`${process.env.PUBLIC_URL}/assets/images/sizes/SolidDarkNeonOrange.webp`}
							alt={`Large solid image`}
						/>
						<img
							className={`sizeImage`}
							src={`${process.env.PUBLIC_URL}/assets/images/sizes/MulticolorPinkClouds.webp`}
							alt={`Large multicolor image`}
						/>
					</div>
					<div className="sizes__content_data_item_info">
						<p>{t('sizes.large')}</p>
						<span>{t('sizes.solidMulticolored')}</span>
					</div>
				</div>
				<div className="sizes__content_data_item medium">
					<div className="images">
						<img
							className={`sizeImage`}
							src={`${process.env.PUBLIC_URL}/assets/images/sizes/SolidBrightSun.webp`}
							alt={`Large solid image`}
						/>
					</div>
					<div className="sizes__content_data_item_info">
						<p>{t('sizes.medium')}</p>
						<span>{t('sizes.onlySolid')}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SizesSection;